import Vue from 'vue';

(function(Vue, document) {

  Vue.directive('ReadMore', {
    bind: function (el, binding, vnode) {

      const paragraphs = Array.from(el.getElementsByTagName('p'));

      if(paragraphs.length > 1) {

        let readMoreContainer = document.createElement('div');
        readMoreContainer.classList.add('read-more');

        if(binding.value) {
          readMoreContainer.classList.add('read-more--show');
        }

        for (var i = 1; i < paragraphs.length; i++) {
          const currentParagraph = paragraphs[i];
          readMoreContainer.appendChild(currentParagraph);
        }
        el.appendChild(readMoreContainer);

        vnode.context.$store.dispatch('readmore/updateShowReadMore', true);

      }
    }
  });

}(Vue, document));



// WEBPACK FOOTER //
// ./directives/read-more.js